export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14479.694e65c3.jpg";